import { SESSION_KEYS } from '@/constants.js';

export default {
  userIsInternal(state) {
    if (state.isInternal) {
      return true;
    }

    const sessionValue = localStorage.getItem(SESSION_KEYS.isInternal);
    if (sessionValue && sessionValue === 'true') {
      return true;
    }

    return false;
  },

  currentCompanyApiUrl(state) {
    if (!state.companyApiUrls) {
      return process.env.VUE_APP_API_URL;
    }

    return (
      state.companyApiUrls[state.currentCompanyId] ??
      process.env.VUE_APP_API_URL
    );
  },

  recommendedChannel(state) {
    return state.recommendedChannel;
  }
};
